<ng-keyboard-shortcuts-help [key]="'f1'" [closeKey]="'escape'" [title]="'shortcuts.title' | transloco"></ng-keyboard-shortcuts-help>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<router-outlet></router-outlet>
